module.exports = __webpack_public_path__ + "img/search_dark.3e588e67.webp";